import ReactMarkdown from 'react-markdown';
import { styled } from '@mui/material/styles';

export const StyledReactMarkdown = styled(ReactMarkdown)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  wordBreak: 'break-word',

  '& > ul, & > ol': {
    paddingLeft: '24px',
  },

  '& > *': {
    margin: '0',
  },
}));
